import {UserPermission} from '@interface/user-permission';
import {UserRole} from '@enum/user-roles/user-role';
import {AllInterCompanyFields, InterCompanyField} from '@enum/client/inter-company-field';
import {UserAreaFilter} from '@enum/user-area/user-area-filter';
import {OrderModalComponent} from '../../../components/order-modal/order-modal.component';
import {UserPermissionManager} from './user-permission';
import {ProformaLabels} from '../proforma-cart-labels/proforma-labels';
import {AllUserAreaColumns} from '@enum/user-area/user-area-column';
import {PartnerType} from '@enum/user-roles/partner-type';
import {CrmSection} from '@enum/crm-section';

class ShowRoomPermissionClass implements UserPermission {
  readonly userRole = UserRole.SELLER;
  readonly labelRole = 'Show Room';
  readonly isAuthenticated = true;

  readonly canRequestEto = true;
  readonly isDefaultUntaxedPrice = true;
  readonly canAlwaysGoToConfigurationSummary = false;

  readonly canModifyAllConfigurations = false;
  readonly canSeeConfigurationsPrice = true;

  readonly hasMoreClients = true;
  readonly canSeeHisAccountInRightDrawer = false;
  readonly canSeeHisAccountPreferences = true;
  readonly canHaveManyEditableProforma = true;
  readonly canModifyCountry = true;

  readonly canRegisterShopVendorFinalUser = true;
  readonly canSeeAlternativeExternalCustomersTab = true;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = true;
  readonly crmSectionsVisible = [CrmSection.VerifiedContact, CrmSection.CustomerList, CrmSection.SalesTasks, CrmSection.Orders, CrmSection.Messages, CrmSection.Claims];
  readonly isLabelRoleVisibleInHeader = false;

  readonly proformaCartLabels = ProformaLabels;

  readonly visibleInterCompanyDependentFields = AllInterCompanyFields;
  readonly editableInterCompanyDependentFields = [InterCompanyField.AGENCY];

  readonly visibleUserAreaFilters = [UserAreaFilter.USERID, UserAreaFilter.CUSTOMERCHANNEL, UserAreaFilter.AGENCY, UserAreaFilter.SHOPVENDOR];
  readonly visibleUserAreaColumns = AllUserAreaColumns;

  readonly orderViewModal = OrderModalComponent;

  readonly canAssignCrmTaskToOthers = true;
  readonly canSeeAssignedUserStats = false;

  readonly canSelfAssignClaims = false;
  readonly canEditClaimAnswer = false;
  readonly canOpenNewClaims = true;
  readonly canHandleAdvancedClaimInfo = false;

  readonly canGiveExpirationFeedback = true;
  readonly canDownloadPackingList = true;
  readonly canSeeConfigurationList = true;
  readonly canSeeCustomerConfigurationTab = true;
  readonly canSeeSummaryRecap = false;
  readonly canEditProbability = true;

  readonly composerAllowed = true;
}

const ShowRoomPermission = new ShowRoomPermissionClass();

UserPermissionManager.instance.assignPermissionWithCheckingFn(ShowRoomPermission,
  ({role, partnerType}) => role === ShowRoomPermission.userRole && partnerType === PartnerType.Showroom
);
